import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindMariageLandingContent($id: String!)
{
  findMariageLandingContent(id: $id) {
    data {
      pageTitle {
        iv
      }
      seoDescription {
        iv
      }
      seoKeywords {
        iv
      }
      seoThumbnail {
        iv {
          url
        }
      }
      carouselItems2 {
        iv {
          title
          subTitle
          fontSizeTitle
          fontSizeSubTitle
          color
          link
          picture {
              url
              fileSize
          }
          textColor
          justification
        }
      }
      labelTitle1 {
        iv
      }
      labelTitleFontColor {
        iv
      }
      labelTitleFontSize {iv}
      currentlyLabel {
        iv
      }
      moreLabel {
        iv
      }
      carouselItems {
        iv {
          title
          subTitle
          tagline
          width
          color
          ctaLink
          ctaText
          ctaStyle
          ctaLink2
          ctaText2
          ctaStyle2
          picture {
              url
              fileSize
          }
          textColor
          horizontalPosition
          justification
        }
      }
      imageBlocList {
        iv {
          color
          ctaLink
          ctaText
          ctaStyle
          picture {
            url
            fileSize
          }
          subTitle
          textColor
          title
        }
      }
    }
  }
}
`,
]);
